export const nodeList = [
  {
    text: '开始',
    type: 'start',
    class: 'node-start'
  },
  {
    text: '条件',
    type: 'exclusiveGateway',
    class: 'node-exclusiveGateway'
  },
  {
    type: 'user',
    text: '用户',
    class: 'node-user'
  },
  {
    type: 'setting',
    text: '服务',
    class: 'node-setting'
  },
  // {
  //   type: 'task',
  //   text: '事务',
  //   class: 'node-task'
  // },
  {
    type: 'confluence',
    text: '合流',
    class: 'node-confluence'
  },
  {
    type: 'distributary',
    text: '分流',
    class: 'node-distributary'
  },
  {
    type: 'end',
    text: '结束',
    class: 'node-end'
  },
];

export const BpmnNode = [
  {
    type: 'bpmn:startEvent',
    text: '开始',
    class: 'bpmn-start'
  },
  {
    type: 'bpmn:endEvent',
    text: '结束',
    class: 'bpmn-end'
  },
  {
    type: 'bpmn:exclusiveGateway',
    text: '网关',
    class: 'bpmn-exclusiveGateway'
  },
  {
    type: 'bpmn:userTask',
    text: '用户',
    class: 'bpmn-user'
  },

]



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/config.js